import { Volume2, VolumeX } from "lucide-react";
import { useChompMute } from "@/lib/chomp";

// Speaker button that mutes/unmutes one chomp sound on this phone.
export default function ChompToggle({ kind = "deal", testid, className = "bg-white/10 hover:bg-white/20" }) {
  const [muted, toggle] = useChompMute(kind);
  const what = kind === "rare" ? "rare find" : "deal";
  return (
    <button type="button" onClick={toggle} aria-pressed={muted} aria-label={muted ? `Turn ${what} sound on` : `Mute ${what} sound`} title={muted ? "Sound off" : "Sound on"}
      className={`shrink-0 rounded-full p-2 transition-colors ${className}`} data-testid={testid}>
      {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
    </button>
  );
}
